"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

const isFeatureFlagActive = ({
  featureFlags,
  featureFlagId,
  applicationPermissions
}) => {
  const doesFlagExist = featureFlags.find(flag => flag.id === featureFlagId);

  if (!doesFlagExist) {
    return false;
  } // FEATURE FLAG permission override


  for (let {
    name
  } of applicationPermissions) {
    if (name === 'FEATURE FLAG') {
      return true;
    }
  }

  return doesFlagExist.active;
};

var _default = isFeatureFlagActive;
exports.default = _default;